
import { defineComponent, reactive, ref } from 'vue';
import TelaPadraoCrud from '@/core/components/TelaPadraoCrud.vue';
import { useCrudBase } from '@/core/composables/CrudBase';
import ProdutoModal from '@/views/Cadastros/Produtos/ProdutoModal.vue';
import { ECustomRenderRow } from '@/core/models/AntDesign/IColumn';
import { IOrdenacao } from '@/core/models/Consulta/IOrdenacao';
import ServicoProduto from '@/servicos/Cadastros/Produtos/ServicoProduto';
import { EPermissaoDados } from '@/models/Enumeradores/MeuSistema/Usuarios/EPermissaoDados';
import ImportacaoRegistrosExcelModal from '@/views/Cadastros/Produtos/ImportacaoRegistrosExcelModal.vue';
import KitsProdutosModal from '@/views/Cadastros/Produtos/KitsProdutosModal.vue';
import storeSistema from '@/store/storeSistema';
import Icone from '@/core/components/Icone.vue';
import AlteracaoEmMassaProdutos from './AlteracaoEmMassaProdutos.vue';
import ImprimirEtiquetasProdutosModal from './ImprimirEtiquetasProdutosModal.vue';
import UtilitarioGeral from '@/core/utilitarios/UtilitarioGeral';
import { ITelaComunicacao } from '@/core/models/ITelaComunicacao';
import { IArquivoPdf } from '@/core/models/IArquivoPdf';

export default defineComponent({
  name: 'Produto',
  components: {
    TelaPadraoCrud,
    ProdutoModal,
    ImportacaoRegistrosExcelModal,
    KitsProdutosModal,
    Icone,
    AlteracaoEmMassaProdutos,
    ImprimirEtiquetasProdutosModal,
  },
  setup() {
    const {
      crudBase, preencherEstrutura, exibirModal, sincronizaTelaCrud,
    } = useCrudBase();
    const servicoProduto = new ServicoProduto();
    const refCrudProduto = ref<InstanceType<typeof TelaPadraoCrud>>();

    crudBase.estrutura = preencherEstrutura();
    crudBase.estrutura.apresentarEmpresas = true;
    crudBase.estrutura.verificarCadastroCompartilhado = true;
    crudBase.estrutura.apresentarAcaoDuplicarGrade = true;
    crudBase.estrutura.apresentarAcaoImprimirEtiqueta = true;
    crudBase.estrutura.botaoPrincipalAcao = 'Novo';
    crudBase.estrutura.mensagemExclusao = 'Você confirma a exclusão do produto:';
    crudBase.estrutura.colunasGrade = [
      {
        title: 'Identificador', dataIndex: 'codigo', key: 'IdentificadorProduto', position: 0, visible: false, ordering: false,
      },
      {
        // Reativar ordering após ajuste da query no backend para ordenação por código interno.
        title: 'Código Interno', dataIndex: 'codigoInterno', key: 'CodigoInterno', identificadorConsulta: 'CodigoInterno', position: 0, visible: true, ordering: false, fixed: 'left', width: 200,
      },
      {
        title: 'Descrição', dataIndex: 'descricao', key: 'DescricaoProduto', identificadorConsulta: 'DescricaoProduto', position: 1, visible: true, ordering: true, fixed: 'left', ellipsis: true, width: 400, align: 'left', customRenderRow: ECustomRenderRow.LinkAcao,
      },
      {
        title: 'Unidade', dataIndex: 'unidade', key: 'UnidadeProduto', position: 2, visible: true, ordering: false, align: 'center', width: 70,
      },
      {
        title: 'Marca', dataIndex: 'marca', key: 'marcaProduto', identificadorConsulta: 'marcaProduto', position: 3, visible: true, ordering: true, align: 'left', ellipsis: true, width: 150,
      },
      {
        title: 'Possui Variação', dataIndex: 'possuiVariacao', key: 'possuiVariacao', position: 4, visible: true, ordering: false, align: 'center', width: 130,
      },
      {
        title: 'Status', dataIndex: 'ativo', key: 'AtivoProduto', position: 5, visible: true, align: 'left', customRenderRow: ECustomRenderRow.TagAtivo, width: 80,
      },
      {
        title: 'NCM', dataIndex: 'ncm', key: 'ncmProduto', identificadorConsulta: 'ncmProduto', position: 6, visible: true, ordering: true, align: 'left',
      },
      {
        title: 'Ações', key: 'acoes', position: 7, visible: true, fixed: 'right', width: 200, align: 'center', customRenderRow: ECustomRenderRow.IconeAcoes,
      },
    ];
    crudBase.estrutura.ordenacaoPadraoGrade.push({ identificador: 'IdentificadorProduto', ordem: 'DESC' } as IOrdenacao);

    const state = reactive({
      exibirImportacaoExcel: false,
      exibirKits: false,
      exibirAlteracao: false,
      exibirImprimirEtiquetas: false,
      codigosSelecionados: [] as number[],
    });

    function abrirImportacaoRegistros() {
      state.exibirImportacaoExcel = true;
    }

    function abrirKits() {
      state.exibirKits = true;
    }

    function abrirAlteracaoEmMassa() {
      if (UtilitarioGeral.validaLista(state.codigosSelecionados)) {
        state.exibirAlteracao = true;
      }
    }

    function abrirImprimirEtiquetas() {
      if (UtilitarioGeral.validaLista(state.codigosSelecionados)) {
        state.exibirImprimirEtiquetas = true;
      }
    }

    function exibirPdfEtiquetas(link: string) {
      if (refCrudProduto.value !== undefined) {
        refCrudProduto.value.tela.arquivosPdf = [{ nome: '', link } as IArquivoPdf];
      }
    }

    async function sincronizarRegistro(acao: EPermissaoDados, codigoRegistro: number) {
      if (refCrudProduto.value !== undefined) {
        await refCrudProduto.value.sincronizarRegistro(acao, codigoRegistro);
      }
    }

    function sincronizaTelaCrudPai(tela: ITelaComunicacao) {
      sincronizaTelaCrud(tela);
      state.codigosSelecionados = [...tela.codigosSelecionados];
    }
    return {
      state,
      storeSistema,
      crudBase,
      servicoProduto,
      refCrudProduto,
      exibirModal,
      sincronizaTelaCrud,
      sincronizarRegistro,
      abrirImportacaoRegistros,
      abrirKits,
      sincronizaTelaCrudPai,
      abrirAlteracaoEmMassa,
      abrirImprimirEtiquetas,
      exibirPdfEtiquetas,
    };
  },
});
